import { Flex, Text, useBreakpointValue } from "@chakra-ui/react";
import { Button as MetriportButton } from "../shared-components/button";

interface ConsolidatedDataIsReadyToast {
  onRefreshClick: () => void;
}

export function ConsolidatedDataIsReadyToast({ onRefreshClick }: ConsolidatedDataIsReadyToast) {
  const buttonSize = useBreakpointValue({ base: "xs", lg: "sm" });
  return (
    <Flex
      bg="green.500"
      color="white"
      p={4}
      borderRadius="md"
      alignItems="center"
      justifyContent="space-between"
    >
      <Text>Data is ready!</Text>
      <MetriportButton
        size={buttonSize}
        onClick={onRefreshClick}
        height="auto"
        py={1}
        bg="white"
        color="green.600"
        _hover={{ bg: "green.50" }}
      >
        Reload Page
      </MetriportButton>
    </Flex>
  );
}
